import { Component } from '@angular/core';
import { LayoutModule } from '../../../layout/layout.module';
import { WorkspaceModule } from '../../../../workspace/workspace.module';

@Component({
  selector: 'app-calendar-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    WorkspaceModule,
  ],
  templateUrl: './calendar-dashboard-page.component.html',
})
export class CalendarDashboardPageComponent { }
